import * as React from 'react';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

const UkrainaNezlamnaSylnaTalanovyta = () => {
  return (
    <Layout>
      <article>
        <h2>
          Увага! Увага! Конкурс! <br />
          “Україна незламна, сильна, талановита”
        </h2>
        <p className="top-spacing-big">
          Запрошуємо наших маленьких вихованців взяти участь в конкурсі “Україна незламна, сильна, талановита” у рамках
          фестивалю дитячої творчості “Сяйво талантів”, що проводиться в КЗ “ЗДО «Лісова казка» ВМР” з 22.05.2023 по
          09.06.2023 з метою популяризації української сучасної та народної культури, культурних цінностей та
          національної пам’яті українського народу, підтримки та розвитку художньо-музичної творчості та удосконалення
          естетичного виховання дошкільників.
        </p>
        <p className="top-spacing-small">
          Пропонуємо розкрити творчий потенціал ваших дітей, надати можливість проявити їх індивідуальність в наступних
          жанрових номінаціях конкурсу:
        </p>
        <p className="top-spacing-small">Вокальний (солісти, дуети, ансамблі):</p>
        <ul>
          <li>дитячі українські народні пісні;</li>
          <li>сучасні дитячі пісні українською мовою;</li>
          <li>дитячі пісні народів світу;</li>
          <li>авторські пісні членів родини тощо.</li>
        </ul>
        <p className="top-spacing-small">Вокальний (солісти, дуети, ансамблі):</p>
        <ul>
          <li>народний танок;</li>
          <li>народна стилізація;</li>
          <li>сучасна хореографія;</li>
          <li>бальний танок;</li>
          <li>спортивний танок;</li>
          <li>танці народів світу тощо.</li>
        </ul>
        <p className="top-spacing-small"> Художнє читання:</p>
        <ul>
          <li>вірші патріотичного спрямування;</li>
          <li>гуморески;</li>
          <li>вірші іноземною мовою;</li>
          <li>авторські вірші членів родини;</li>
          <li>твори сучасних авторів та класиків української літератури тощо.</li>
        </ul>
        <p className="top-spacing-small">Оригінальний:</p>
        <ul>
          <li>пісочна анімація;</li>
          <li>циркові номери; </li>
          <li>фокуси тощо.</li>
        </ul>
        <p className="top-spacing-small">Інструментальний (ударні, духові, струнні, фортепіано тощо).</p>
        <ul>
          <li>соло;</li>
          <li>ансамбль;</li>
          <li>оркестр.</li>
        </ul>
        <p className="top-spacing-small">Тривалість відеороликів до 4 хв.</p>
        <p className="top-spacing-small">
          Відео або фотопрезентацію вашого конкурсного виступу необхідно розмістити на офіційній сторінці закладу КЗ
          “ЗДО «Лісова казка» ВМР” у фейсбук під хештегом #НАС_ЄДНАЄ_УКРАЇНА_ВІРА_В_ПЕРЕМОГУ!
        </p>
        <p className="top-spacing-small">Бажаємо вам творчих успіхів!</p>
        <p className="top-spacing-small">З нетерпінням чекаємо на ваші відеоролики!</p>
      </article>
    </Layout>
  );
};

export default UkrainaNezlamnaSylnaTalanovyta;

export const Head = () => <SEO title="День захисту дітей" />;
